import { render, staticRenderFns } from "./searchelement.vue?vue&type=template&id=55575609&"
import script from "./../ts/searchelement.ts?vue&type=script&lang=js&"
export * from "./../ts/searchelement.ts?vue&type=script&lang=js&"
import style0 from "./../assets/css/searchelement.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports